<div class="contenedor-input" [class.contenedor-input-solo-lectura]="soloLectura">
    <label [attr.for]="inputId" class="input-label" [attr.aria-readonly]="soloLectura ? 'true' : null"
        [attr.aria-disabled]="deshabilitado ? 'true' : null">{{ label
        }}</label>
    <input [attr.id]="inputId" class="input-formulario" [attr.inputmode]="inputmode" [type]="tipo"
        [placeholder]="placeholder" [value]="valor" [attr.maxlength]="longitudMaxima" [readonly]="soloLectura"
        [tabindex]="soloLectura ? -1 : 0" [readonly]="soloLectura" [disabled]="deshabilitado"
        (input)="alCambiarInput($event)" (keypress)="alPresionarTecla($event)" (paste)="alPegar($event)"
        (contextmenu)="alMenuContextual($event)" />
</div>